var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetClassificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 11C15.1963 11 15.8675 11.2422 16.4014 11.6797L16.6211 11.8789C17.1837 12.4415 17.5 13.2044 17.5 14C17.5 14.7956 17.1837 15.5585 16.6211 16.1211C16.0585 16.6837 15.2956 17 14.5 17C13.8037 17 13.1325 16.7578 12.5986 16.3203L12.3789 16.1211C11.8163 15.5585 11.5 14.7956 11.5 14L11.5146 13.7031C11.5732 13.1145 11.8048 12.5562 12.1797 12.0986L12.3789 11.8789C12.8711 11.3867 13.5165 11.0829 14.2031 11.0146L14.5 11Z",
    stroke: "#004A96",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10C3.43913 10 2.42172 10.4214 1.67157 11.1716C0.921427 11.9217 0.5 12.9391 0.5 14C0.5 15.0609 0.921427 16.0783 1.67157 16.8284C2.42172 17.5786 3.43913 18 4.5 18C5.56087 18 6.57828 17.5786 7.32843 16.8284C8.07857 16.0783 8.5 15.0609 8.5 14C8.5 12.9391 8.07857 11.9217 7.32843 11.1716C6.57828 10.4214 5.56087 10 4.5 10Z",
    fill: "#004A96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4C10.5 2.93913 10.9214 1.92172 11.6716 1.17157C12.4217 0.421427 13.4391 0 14.5 0C15.5609 0 16.5783 0.421427 17.3284 1.17157C18.0786 1.92172 18.5 2.93913 18.5 4C18.5 5.06087 18.0786 6.07828 17.3284 6.82843C16.5783 7.57857 15.5609 8 14.5 8C13.4391 8 12.4217 7.57857 11.6716 6.82843C10.9214 6.07828 10.5 5.06087 10.5 4Z",
    fill: "#004A96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 0C3.43913 0 2.42172 0.421427 1.67157 1.17157C0.921427 1.92172 0.5 2.93913 0.5 4C0.5 5.06087 0.921427 6.07828 1.67157 6.82843C2.42172 7.57857 3.43913 8 4.5 8C5.56087 8 6.57828 7.57857 7.32843 6.82843C8.07857 6.07828 8.5 5.06087 8.5 4C8.5 2.93913 8.07857 1.92172 7.32843 1.17157C6.57828 0.421427 5.56087 0 4.5 0Z",
    fill: "#004A96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetClassificationIcon);
export default __webpack_public_path__ + "static/media/SetClassificationIcon.484814496b617a4dabd66148c2955272.svg";
export { ForwardRef as ReactComponent };